import { Button } from "components"
import { Box } from "theme-ui"
import "./style/style.css"

export const PlantData = () => {
 return (
  <div className="relative h-screen  md:h-screen lg:h-full w-[96%] mx-auto">
   <h1 className="Jakarta-font font-bold text-xl py-6">Anlage bearbeiten</h1>

   <ul className="flex w-full Jakarta-font">
    <li className="text-lg p-4 bg-white cursor-pointer rounded-t-md">
     <a href="/">STm.5</a>
    </li>
    <li className="text-lg p-4 bg-light-gray2 cursor-pointer rounded-t-md">
     <a href="/">STm.6</a>
    </li>
    <li className="text-lg p-4 bg-light-gray2 cursor-pointer rounded-t-md">
     <a href="/">Testanlage 01</a>
    </li>
    <li className="text-lg p-4 bg-light-gray2 cursor-pointer rounded-t-md">
     <a href="/">Testanlage Copy 01</a>
    </li>
    <li className="text-lg p-4 bg-light-gray2 cursor-pointer rounded-t-md">
     <a href="/">USM-Test</a>
    </li>
    <li className="text-lg p-4 bg-light-gray2 cursor-pointer rounded-t-md">
     <a href="/"> XXX XXX</a>
    </li>
   </ul>
   <Box bg="highlight" className="flex flex-col justify-between items-center">
    <div className="flex flex-wrap gap-2.5 py-3 px-3">
     <Button size={"xl"} className="w-max">
      Anlagendaten
     </Button>
     <Button size={"xl"} className="w-max" color={"white"}>
      Signalprogramme
     </Button>
     <Button size={"xl"} className="w-max" color={"white"}>
      Signalgruppen
     </Button>
     <Button size={"xl"} className="w-max" color={"white"}>
      Detektoren
     </Button>
     <Button size={"xl"} className="w-max" color={"white"}>
      ÖPNV-Meldepunkte
     </Button>
     <Button size={"xl"} className="w-max" color={"white"}>
      AP-Werte
     </Button>
     <Button size={"xl"} className="w-max" color={"white"}>
      OCIT-Listen
     </Button>
     <Button size={"xl"} className="w-max" color={"white"}>
      OCIT-I-Einstellungen
     </Button>
     <Button size={"xl"} className="w-max" color={"white"}>
      Anlagengruppen
     </Button>
    </div>
    <div className="w-full">
     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">Zentrale:</p>
      <input
       type="text"
       name=""
       placeholder="Testserver"
       className="text-base font-medium placeholder-dark-black bg-light-gray2 w-[35%] py-4 px-5 rounded-lg"
      />
     </div>

     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">Feldgerät-Nr:</p>
      <input
       type="text"
       name=""
       placeholder="6"
       className="text-base font-medium placeholder-dark-black bg-light-gray2 w-[35%] py-4 px-5 rounded-lg"
      />
     </div>
     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">Anlagenart (VS/FG):</p>
      <input
       type="text"
       name=""
       placeholder="VS"
       className="text-base font-medium placeholder-dark-black bg-light-gray2 w-[35%] py-4 px-5 rounded-lg"
      />
     </div>
     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">LSA-Name/Nummer:</p>
      <div className="flex w-[35%] gap-x-1">
       <input
        type="text"
        name=""
        placeholder="USM-Test"
        className="text-base font-medium placeholder-dark-black bg-light-gray2 py-4 px-5 rounded-lg w-3/5"
       />

       <input
        type="text"
        name=""
        placeholder=""
        className="text-base font-medium placeholder-dark-black bg-light-gray2 py-4 px-5 rounded-lg w-2/5"
       />
      </div>
     </div>
     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">Standort:</p>
      <input
       type="text"
       name=""
       placeholder="Gera"
       className="text-base font-medium placeholder-dark-black bg-light-gray2 w-[35%] py-4 px-5 rounded-lg"
      />
     </div>
     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">Standort:</p>
      <div className="flex w-[35%]">
       <div className="flex-1 pt-2">
        <input
         className="blackRadio"
         type="radio"
         id="greenbelt-radiobutton"
         name="commonradiobutton"
        ></input>
        <label className="pl-2" htmlFor="greenbelt-radiobutton">
         VA
        </label>
       </div>
       <div className="flex-1 pt-2">
        <input
         className="blackRadio"
         type="radio"
         id="greenbelt-radiobutton"
         name="commonradiobutton"
        ></input>
        <label className="pl-2" htmlFor="greenbelt-radiobutton">
         ÖPNV
        </label>
       </div>
       <div className="flex-1 pt-2">
        <input
         className="blackRadio"
         type="radio"
         id="greenbelt-radiobutton"
         name="commonradiobutton"
        ></input>
        <label className="pl-2" htmlFor="greenbelt-radiobutton">
         IV
        </label>
       </div>
      </div>
     </div>
     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">IP-Adresse</p>
      <input
       type="text"
       name=""
       placeholder="192.168.6.86"
       className="text-base font-medium placeholder-dark-black bg-light-gray2 w-[35%] py-4 px-5 rounded-lg"
      />
     </div>
     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">Schnittstelle:</p>
      <input
       type="text"
       name=""
       placeholder="LAN-Anschluss (Ethernet)"
       className="text-base font-medium placeholder-dark-black bg-light-gray2 w-[35%] py-4 px-5 rounded-lg"
      />
     </div>
     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">Koordinaten:</p>
      <div className="flex justify-between w-5/11">
       <div className="flex gap-x-4 items-center w-2/4">
        <input
         type="text"
         name=""
         placeholder=" 50.90280"
         className="text-base font-medium placeholder-dark-black bg-light-gray2 text-dark-black w-[75%] py-4 px-5 rounded-lg"
        />
        <p className="text-base font-bold text-dark-black">Nord</p>
       </div>
       <div className="flex gap-x-4  items-center w-2/4">
        <input
         type="text"
         name=""
         placeholder=" 50.90280"
         className="text-base font-medium placeholder-dark-black bg-light-gray2 text-dark-black w-[75%] py-4 px-5 rounded-lg"
        />
        <p className="text-base font-bold text-dark-black">Ost</p>
       </div>
      </div>
     </div>
     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">Koordinaten:</p>
      <div className="flex gap-x-6 items-center justify-between w-[35%] ">
       <input
        type="text"
        name=""
        placeholder="6"
        className="text-base font-medium placeholder-dark-black bg-light-gray2 text-dark-black w-[75%] py-4 px-5 rounded-lg"
       />
       <p className="flex-1 text-base font-bold text-dark-black">Monate</p>
      </div>
     </div>
     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">Lampenwechselintervall:</p>
      <div className="flex gap-x-6 items-center justify-between w-[35%] ">
       <input
        type="text"
        name=""
        placeholder="1"
        className="text-base font-medium placeholder-dark-black bg-light-gray2 text-dark-black w-[75%] py-4 px-5 rounded-lg"
       />
       <p className="flex-1 text-base font-bold text-dark-black">Monate</p>
      </div>
     </div>
     <div className="flex justify-between items-center w-full text-dark-black py-3 px-8 border-b border-light-gray">
      <p className="text-sm font-semibold">Bemerkungen:</p>
      <input
       type="text"
       name=""
       placeholder="Enter here..."
       className="text-base font-medium placeholder-dark-black bg-light-gray2 w-[35%] py-4 px-5 rounded-lg outline-none"
      />
     </div>
    </div>

    <div className="flex gap-x-2 justify-center py-8 ">
     <div>
      <Button color={"green"} size={"doublexl"}>
       Speichern
      </Button>
     </div>
     <div className="">
      <Button color={"lightBrown"} size={"doublexl"}>
       Neu
      </Button>
     </div>
     <div className="">
      <Button color={"pink"} size={"doublexl"}>
       Loschen
      </Button>
     </div>
     <div className="">
      <Button color={"blue"} size={"doublexl"}>
       XML-Upload
      </Button>
     </div>
    </div>
   </Box>
  </div>
 )
}
